import React, { Component, Fragment } from 'react';
import { ProductCompliance } from '~/Api/CzSuklCompliance';
import { formatHumanDate } from '~/DateTime';
import Icon from '~/UI/Icon/Icon';
import Tooltip from '~/UI/Tooltip';

import styles from './styles.less';

interface Props {
	compliance: ProductCompliance;
}

export default class ComplianceIcon extends Component<Props> {
	render() {
		const { compliance } = this.props;
		const title = compliance.resolveRuleDescription();

		return title ? (
			<Tooltip
				position='left'
				reference={
					<span className={styles.iconWithTooltip}>
						<Icon name={this.resolveIconName()} />
					</span>
				}
				width={320}
			>
				{title}
				{compliance.decisionComment ? (
					<Fragment>
						<hr className={styles.line} />
						{compliance.decisionComment}
					</Fragment>
				) : null}
				<p className={styles.subPerex}>
					Poznámky ref. zdroje {compliance.czechReferenceDataSources.version} z&nbsp;
					{formatHumanDate(compliance.czechReferenceDataSources.effectiveSince, ['cs-CZ'])}
				</p>
			</Tooltip>
		) : (
			<span className={styles.icon}>
				<Icon name={this.resolveIconName()} />
			</span>
		);
	}

	resolveIconName(): string {
		const { compliance } = this.props;

		if (compliance.isAccept) {
			return 'green-checkmark';
		}
		if (compliance.isAcceptNoRulesForDataSource) {
			return 'green-checkmark';
		}
		if (compliance.isAcceptWithWarning) {
			return 'yellow-question-mark';
		}
		if (compliance.isCannotInterpretRules) {
			return 'yellow-question-mark';
		}
		if (compliance.isReject) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectNoPrices) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectNotAReferenceDataSource) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectRemoved) {
			return 'red-exclamation-mark';
		}
		return 'yellow-question-mark';
	}
}
